const ExamType = {
	TYT: 1,
	AYT: 2,
	LGS: 3,
	KPSS: 4,
	YKS: 99, // AYT ve TYT ortak yayınları için
};

export default ExamType;